<template>
  <div class="flex lg:flex-shrink-0 fixed h-full left-0 top-0">
    <div class="flex flex-col w-64 pt-8 bg-navy">
      <div class="flex items-center flex-shrink-0 px-6 pb-8">
        <a :href="LANDING_URL">
          <img
            v-show="!sidebarCollapsed"
            alt="vestbee"
            class="h-auto w-[129px] text-white"
            :src="STATIC_URL + 'images/vestbee_logo_white.png'"
            width="129"
          />
          <img
            v-show="sidebarCollapsed"
            class="h-auto w-[30px] text-white"
            :src="STATIC_URL + 'images/vestbee_sm_logo_white.png'"
            width="30"
          />
        </a>
      </div>
      <div class="px-6">
        <hr class="mx-auto my-0 border-white border-opacity-10" />
      </div>
      <!-- Sidebar component, swap this element with another sidebar if you like -->
      <div class="flex flex-col flex-1 h-0 overflow-y-auto">
        <!-- Navigation -->
        <nav class="px-3 mt-6">
          <div class="space-y-1">
            <MainMenuItem
              v-for="item in navigation"
              :item="item"
              :key="item.name"
              :refresh-on-navigate="item.refreshOnNavigate"
              :link-to-new-app="item.linkToNewApp"
            />
          </div>
        </nav>

        <nav class="px-3 pt-6 mt-auto pb-4">
          <div class="space-y-1">
            <div class="flex items-center">
              <el-dropdown placement="top-end" trigger="click" class="flex-1">
                <button
                  class="w-full group flex items-center px-2.5 py-2.5 text-base rounded-lg transition-all flex-1 hover:no-underline no-underline focus:no-underline active:no-underline text-white text-opacity-50 hover:text-opacity-100 hover:text-white hover:bg-white hover:bg-opacity-[0.08] font-normal"
                >
                  <UserIcon
                    class="mr-3 flex-shrink-0 h-6 w-6 transition-all text-white text-opacity-40 group-hover:text-primary-500"
                  />
                  Your account
                </button>
                <el-dropdown-menu
                  slot="dropdown"
                  class="rounded-xl !bg-navy-light !border-transparent p-1"
                >
                  <router-link
                    :to="{ name: 'changePasswordPage' }"
                    class="sidebar-new-item min-w-[226px]"
                  >
                    Change password
                  </router-link>
                  <CopyClick
                    :text="user.email"
                    placement="right"
                    class="sidebar-new-item min-w-[226px]"
                  >
                    <span>{{ user.email }}</span>
                  </CopyClick>
                </el-dropdown-menu>
                <!--                <el-dropdown-menu slot="dropdown">-->
                <!--                  <el-dropdown-item class="dropdown-item-with-link">-->
                <!--                    <router-link :to="{ name: 'changePasswordPage' }">-->
                <!--                      Change password-->
                <!--                    </router-link>-->
                <!--                  </el-dropdown-item>-->
                <!--                  <el-dropdown-item divided>-->
                <!--                    <CopyClick :text="user.email" placement="right">-->
                <!--                      <span class="username">{{ user.email }}</span>-->
                <!--                    </CopyClick>-->
                <!--                  </el-dropdown-item>-->
                <!--                </el-dropdown-menu>-->
              </el-dropdown>

              <div class="grid ml-0.5 place-items-center">
                <button
                  @click.prevent="logout"
                  class="px-3 text-center group rounded-lg py-2.5 hover:bg-white hover:bg-opacity-[0.08] transition-all"
                  title="Logout"
                >
                  <LogoutIcon
                    class="flex-shrink-0 w-6 h-6 mx-auto text-white transition-all text-opacity-40 group-hover:text-primary-500"
                    aria-hidden="true"
                  />
                </button>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import GlobalSettings from '../../GlobalSettings'
import CopyClick from 'components/CopyClick'
import MainMenuItem from './MainMenuItem'
import {
  CogIcon,
  CollectionIcon,
  HashtagIcon,
  HomeIcon,
  MailIcon,
  TagIcon,
  LogoutIcon,
  UserIcon,
  PresentationChartBarIcon,
  DocumentReportIcon,
  SparklesIcon,
  OfficeBuildingIcon,
  LightBulbIcon,
  ClipboardListIcon,
  ViewListIcon,
} from '@vue-hero-icons/outline'
import { hasAllPerms } from '../../services/Auth'

export default {
  components: {
    CopyClick,
    MainMenuItem,
    UserIcon,
    LogoutIcon,
  },
  computed: {
    ...mapState({
      LANDING_URL: () => GlobalSettings.LANDING_URL,
      user: (state) => state.user.data || {},
      startup: (state) => state.startupProfile.startup || {},
      sidebarCollapsed: (state) => state.common.sidebarCollapsed,
      navBarMobileVisible: (state) => state.common.navBarMobileVisible,
    }),
    startupNavigation() {
      return [
        {
          name: 'Profile',
          href: '/dashboard',
          icon: HomeIcon,
          show: true,
          refreshOnNavigate: true,
        },
        {
          name: 'Links',
          href: '/dashboard/links',
          icon: HashtagIcon,
          show: this.user.isStartup,
          refreshOnNavigate: true,
        },
        {
          name: 'My applications',
          href: '/dashboard/applications',
          icon: CollectionIcon,
          show: true,
          refreshOnNavigate: true,
          linkToNewApp: true,
        },
        {
          name: 'Discounts',
          href: '/dashboard/marketplace',
          icon: TagIcon,
          show: true,
          refreshOnNavigate: true,
        },
        {
          name: 'Messages',
          href: '/dashboard/messages',
          icon: MailIcon,
          show: true,
          refreshOnNavigate: true,
          badge: this.unreadMessagesCount()
            ? {
                type: 'info',
                text: `${this.unreadMessagesCount()}`,
              }
            : undefined,
        },
        {
          name: 'Settings',
          href: '/dashboard/settings',
          icon: CogIcon,
          show: this.user.isStartup && !this.startup.profile_locked,
          refreshOnNavigate: true,
        },
      ]
    },
    organizerNavigation() {
      return (user) => {
        const org = user.organizations[0]
        const role = org && org.role
        const showMyOrg = ['owner', 'admin', 'member'].includes(role)
        const hasDiscountFeatureEnabled =
          org && org.features.includes('discounts')

        return [
          {
            name: 'Dashboard',
            href: '/dashboard',
            icon: HomeIcon,
            show: true,
            refreshOnNavigate: true,
          },
          showMyOrg && {
            name: 'My organization',
            href: '/dashboard/my-organization',
            icon: OfficeBuildingIcon,
            show: true,
            refreshOnNavigate: true,
          },
          {
            name: 'Companies',
            href: '/dashboard/startups',
            icon: CollectionIcon,
            show: true,
            refreshOnNavigate: true,
            children: [
              {
                name: 'New',
                href: '/dashboard/new-startups',
                icon: LightBulbIcon,
                show: true,
                refreshOnNavigate: true,
              },
              {
                name: 'Featured',
                href: '/dashboard/featured-startups',
                icon: ViewListIcon,
                show: true,
                refreshOnNavigate: true,
              },
              {
                name: 'Shortlists',
                href: '/dashboard/shortlists',
                icon: ClipboardListIcon,
                show: true,
                refreshOnNavigate: true,
              },
            ],
          },
          {
            name: 'Programs',
            href: '/dashboard/programs',
            icon: PresentationChartBarIcon,
            show: true,
            refreshOnNavigate: false,
          },
          {
            name: 'Reports',
            href: '/dashboard/reports',
            icon: DocumentReportIcon,
            show: true,
            refreshOnNavigate: false,
          },
          {
            name: 'Showrooms',
            href: '/dashboard/showrooms',
            icon: SparklesIcon,
            show: true,
            refreshOnNavigate: true,
          },
          {
            name: 'Messages',
            href: '/dashboard/messages',
            icon: MailIcon,
            show: true,
            refreshOnNavigate: true,
            badge: this.unreadMessagesCount()
              ? {
                  type: 'info',
                  text: `${this.unreadMessagesCount()}`,
                }
              : undefined,
          },
          {
            name: 'Discounts',
            href: '/dashboard/marketplace',
            icon: TagIcon,
            show: hasDiscountFeatureEnabled,
            refreshOnNavigate: true,
          },
        ].filter((o) => !!o)
      }
    },
    navigation() {
      const items = {
        ADMIN: [],
        STARTUP: this.startupNavigation,
        ORGANIZER: this.organizerNavigation(this.user),
        DEFAULT: [],
      }[this.user.role || 'DEFAULT']

      return items.filter((item) => {
        if (!this.user) {
          return []
        }
        return hasAllPerms(this.user, item.perms || [])
      })
    },
  },
  data: () => ({
    STATIC_URL: GlobalSettings.STATIC_URL,
    followedCountChanged: false,
  }),
  methods: {
    ...mapMutations({
      setNavBarMobileVisibility: 'common/TOGGLE_NAV_BAR_MOBILE',
    }),
    ...mapGetters({
      unreadMessagesCount: 'chat/unreadMessagesCount',
    }),
    logout() {
      this.$router.push({ name: 'logout' })
    },
    collapseNavBar() {
      this.$store.commit('common/COLLAPSE_SIDEBAR')
    },
    expandNavBar() {
      this.$store.commit('common/EXTEND_SIDEBAR')
    },
    toggleNavBarMobile() {
      this.setNavBarMobileVisibility()
    },
  },
}
</script>

<style lang="scss">
@import '~assets/css/colors.scss';
@import '~assets/css/vars.scss';

.el-popper[x-placement*='top']:not(.user-menu-dropdown-old) .popper__arrow {
  @apply border-t-navy-light #{!important};

  &::after {
    @apply border-t-navy-light #{!important};
  }
}

.user-menu-dropdown-old.el-popper[x-placement*='top'] .popper__arrow {
  @apply border-t-white #{!important};

  &::after {
    @apply border-t-white #{!important};
  }
}

.username {
  padding: 0px 14px;
  font-size: 14px;
  color: #999999;
}

.top-nav {
  display: flex;
  padding: 0px 14px;
  @apply bg-navy;

  .logo {
    margin-right: 14px;
  }

  a {
    margin-right: 28px;

    @apply flex items-center self-center;
  }

  i {
    color: $white;
    align-self: center;
    cursor: pointer;
  }
}

.panel-sidebar {
  .nav {
    span.ion,
    ion-icon {
      width: 32px;
      text-align: center;
    }
  }
}

#app.sidebar-collapsed {
  $collapsed-sidebar-width: 54px;

  .panel-sidebar {
    width: $collapsed-sidebar-width;

    .top-nav {
      padding: 0 6px;

      .logo {
        margin-right: 0;
        flex-grow: 1;
      }

      a {
        margin-right: 4px;
      }
    }

    .nav {
      li a {
        padding-left: 12px;
        padding-right: 12px;
      }

      .title {
        display: none;
      }
    }

    .nav-collapsers {
      margin-top: 2px;
    }

    .user-menu {
      margin-left: -80px;
    }

    .dropdown-menu {
      margin-left: 80px;
    }
  }

  .panel-content {
    margin-left: $collapsed-sidebar-width;

    .panel-topnav {
      position: fixed;
      top: 0;
      left: $collapsed-sidebar-width;
      right: 0;
      min-height: 64px;
      background: $white;
      box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.05);
      z-index: 300;

      .panel-controls {
        height: 66px;
        padding: 12px 24px 0;
        border-right: 1px solid $grey180;
      }

      .back-link {
        line-height: 66px;
        padding: 0 30px;
        border-right: 1px solid $grey180;

        &:hover,
        &:focus,
        &:active {
          text-decoration: none;
        }
      }
    }
  }
}

@media screen and (max-width: theme('screens.sm')) {
  .panel-content {
    .panel-topnav {
      background: $grey30;
      height: 65px;
      box-shadow: none;

      .back-link {
        border-right: none;
      }
    }

    .nav-tabs {
      margin: 4px auto;
    }
  }

  .mobile-nav__button {
    background: $grey30;
    border: none;

    i {
      font-size: 30px;
    }

    &:hover {
      background: $grey30;
      border: none;
    }

    &:focus {
      background: $grey30;
    }
  }

  .panel-sidebar {
    height: 65px;
    width: unset;

    .top-nav {
      height: 65px;

      .logo {
        width: 129px;
      }
    }

    z-index: 1000;
    background: none;

    .nav-collapsers {
      display: none;
    }

    .nav-menu {
      display: none;
    }

    .user-menu {
      display: none;
    }
  }

  .panel-sidebar--active {
    background: $grey30;
    width: 100vw;
    z-index: 1002;
    height: 100vh;

    .nav-menu {
      display: initial;
    }

    .user-menu {
      display: initial;
    }
  }
}

.panel-sidebar {
  .user-menu .el-dropdown {
    width: 100%;
    position: absolute;
    bottom: 0;

    .dropdown-button {
      width: 100%;
      padding-right: 25px;

      > span {
        display: inline;
      }
    }
  }

  .nav-menu {
    overflow: auto;
    height: 80vh;
  }
}

#app.sidebar-collapsed {
  .panel-sidebar {
    .user-menu .el-dropdown {
      .dropdown-button {
        .account {
          display: none;
        }
        padding-right: 18px;
      }
    }
  }
}

.user-menu-dropdown {
  .dropdown-item-with-link {
    padding: 0;
    a {
      padding: 0 20px;
      display: block;
    }
  }
}

.sidebar-new-item {
  @apply w-full flex items-center px-2.5 py-2.5 text-base rounded-lg transition-all flex-1 hover:no-underline no-underline focus:no-underline active:no-underline text-white text-opacity-50 hover:text-opacity-100 hover:text-white hover:bg-white hover:bg-opacity-[0.08] font-normal;
}
</style>
